var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content_w_710",attrs:{"id":_vm.content.key}},[_c(_vm.componentsName[_vm.content.type],{tag:"component",attrs:{"content":_vm.content,"canSetWidth":true}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }